import { useState, useEffect } from "react";
import { getVolume, setVolume } from "../../lib/audio";

export default function VolumeControl() {
  const [volume, setVol] = useState(getVolume());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setVol(getVolume());
  }, []);

  const handleChange = (v: number) => {
    setVolume(v);
    setVol(v);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        className="p-2 rounded-lg bg-vsw-900/80 hover:bg-vsw-800 transition-colors"
        title="Sound volume"
      >
        {volume === 0 ? (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" /><path strokeLinecap="round" strokeLinejoin="round" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" /></svg>
        ) : volume < 0.5 ? (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15.536 8.464a5 5 0 010 7.072" /></svg>
        ) : (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728" /></svg>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 p-3 bg-vsw-900 border border-vsw-700 rounded-lg shadow-lg z-50 w-40">
          <label className="text-xs text-vsw-200 mb-2 block">Volume</label>
          <input
            type="range"
            min={0}
            max={1}
            step={0.05}
            value={volume}
            onChange={(e) => handleChange(parseFloat(e.target.value))}
            className="w-full accent-vsw-400"
          />
          <div className="flex justify-between text-[10px] text-vsw-300 mt-1">
            <span>Off</span>
            <span>{Math.round(volume * 100)}%</span>
            <span>Max</span>
          </div>
        </div>
      )}
    </div>
  );
}
